import apiClient from '../client';
import {FeaturedContent} from '../types';

export const fetchFeaturedContent = async (): Promise<FeaturedContent[]> => {
    try {
        const response = await apiClient.get('search/categories');
        return response.data as FeaturedContent[];
    } catch (error) {
        throw new Error('error');
    }
};
